import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OvoStorage } from 'src/app/shared/storage/ovo.storage';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';

@Component({
  selector: 'app-payment-result-ovo',
  templateUrl: './payment-result-ovo.component.html',
  styleUrls: ['./payment-result-ovo.component.css']
})
export class PaymentResultOvoComponent implements OnInit {
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  paymentResult = 'Success';
  isSuccess = true;

  failedReason;

  invoiceNumber: string;
  transactionDate: string;
  ovoBalance: string;
  ovoCash: string;
  merchantName: string;
  transactionAmount: string;
  phoneNumber: string;
  transactionId: string;
  customerName: string;
  ovoPointBalance;
  ovoCashBalance;

  constructor(
    private router: Router,
    private ovoStorage: OvoStorage,
  ) { }

  ngOnInit(): void {
    if (this.ovoStorage.data == null) {
      this.router.navigate([NavigationConstant.OVO_INQUIRY]);
    }

    this.invoiceNumber = this.ovoStorage.data.invoiceNumber;
    this.transactionDate = this.ovoStorage.data.transactionDate;
    this.merchantName = this.ovoStorage.data.merchantName;
    this.transactionAmount = this.ovoStorage.data.transactionAmount;
    this.phoneNumber = this.ovoStorage.data.phoneNumber;
    this.transactionId = this.ovoStorage.data.transactionId;
    this.customerName = this.ovoStorage.data.name;
    this.ovoPointBalance = this.ovoStorage.data.response.ovoBalance;
    this.ovoCashBalance = this.ovoStorage.data.response.ovoCash;
    let responseCode = this.ovoStorage.data.response.responseCode;

    if (responseCode !== '00') {
      this.paymentResult = 'Failed';
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      this.isSuccess = false;

      this.mapResponse(responseCode);

    }

  }

  goToInquiry() {
    this.router.navigate([NavigationConstant.OVO_INQUIRY]);
  }

  mapResponse(responseCode) {
    switch (responseCode) {
      case '14':
        this.failedReason = 'Invalid Mobile Number';
        break;

      case '17':
        this.failedReason = 'Transaction Decline';
        break;

      case '25':
        this.failedReason = 'Transaction Not Found';
        break;

      case '26'||'40'||'65':
        this.failedReason = 'Transaction Failed';
        break;

      case '54':
        this.failedReason = 'Transaction Expired';
        break;

      case '56':
        this.failedReason = 'Card Blocked. Please Call 1500696';
        break;

      case '58':
        this.failedReason = 'Transaction Not Allowed';
        break;

      case '61':
        this.failedReason = 'Exceed Transaction Limit';
        break;

      case '63':
        this.failedReason = 'Security Violation';
        break;

      case '64':
        this.failedReason = 'Account Blocked. Please Call 1500696';
        break;

      case '67':
        this.failedReason = 'Below Transaction Limit';
        break;

      case '68':
        this.failedReason = 'Transaction Pending / Timeout';
        break;

      case '73':
        this.failedReason = 'Transaction has been reversed';
        break;

      case '96':
        this.failedReason = 'Invalid Processing Code';
        break;

      case 'ER':
        this.failedReason = 'System Failure';
        break;

      case 'EB':
        this.failedReason = 'Terminal Blocked';
        break;

      default:
        this.failedReason = 'Unknown Error';
        break;
    }
  }

}
